import { util } from '@didi/soda-common'

const { env } = util

export const DOWNLOAD_URL = {
  // 嵌入端
  global: env.isIOS ? 'itms-apps://itunes.apple.com/app/cn/id1362398401?mt=8' : 'https://play.google.com/store/apps/details?id=com.didiglobal.passenger',
  // 独立端
  sodaCustomer: env.isIOS ? 'itms-apps://itunes.apple.com/app/cn/id1434256853?mt=8' : 'https://play.google.com/store/apps/details?id=com.xiaojukeji.didi.global.customer',
  '99Travel': env.isIOS ? 'https://apps.apple.com/br/app/99-carro-particular-e-t%C3%A1xi/id553663691' : 'https://play.google.com/store/apps/details?id=com.taxis99',
  '99Food': env.isIOS ? 'https://apps.apple.com/br/app/99-food/id1480806762' : 'https://play.google.com/store/apps/details?id=com.xiaojukeji.didi.brazil.customer'
}
